import { ButtonGroup as MuiButtonGroup } from '@mui/material';

import { ToggleButton } from './toggle-button.component';
import { ToggleButtonGroupProps } from './toggle-button.types';

import { Typography } from '../../data-display/typography/typography.component';

export const ToggleButtonGroup = ({
  buttons,
  value,
  onChange,
  label,
  orientation,
  variant,
  disabled,
  fullWidth,
  fitToContent,
}: ToggleButtonGroupProps) => (
  <>
    {label && <Typography paragraph>{label}</Typography>}
    <MuiButtonGroup
      color='primary'
      size='large'
      orientation={orientation}
      variant={variant}
      disabled={disabled}
      sx={[
        fullWidth ? { display: 'flex' } : null,
        fitToContent && !fullWidth ? { width: 'fit-content', maxWidth: '100%' } : null,
      ]}
    >
      {buttons.map((item) => (
        <ToggleButton
          key={typeof item.value === 'string' ? item.value : item.key}
          fitToContent={fitToContent}
          onClick={onChange}
          value={item.value}
          selected={item.value === value}
        >
          {item.title}
        </ToggleButton>
      ))}
    </MuiButtonGroup>
  </>
);
